import {
  ActionField,
  ActionFieldChildProps,
  useFormContext,
} from '@oscar/form';
import { Request } from '@oscar/request';
import { Button, notification, Space } from '@oscar/theme';
import { ActionButtonTable, Popup } from 'common/components';
import { APIS } from 'common/constants/endpoints';
import { REQUEST_TYPE } from 'common/constants/insulation';
import { useAuth } from 'features/auth';
import { MAP_REQUEST_NAME } from 'features/insulation';
import { correctData } from 'features/insulation/utils';
import { forEach, get } from 'lodash';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  convertMomentToString,
  getServiceByURL,
  validateData,
} from 'views/pages/create-instrulation/utils';
import PopupFinalSubmitQaqc from '../QaqcDetail/component/PopupFinalSubmitQaqc';
import { RemovalChecklist } from '../RemovalChecklist';
import '../style.scss';
import axios from 'axios';

const TYPE = {
  POSTPONE: 0,
  SUBMIT: 1,
};

const getConfigQAQC = (status: any, auth: any) => {
  return [
    {
      id: 1,
      key: 'All',
      request: {
        name: 'Submit',
        url: APIS.QAQC_PAINTING_SUBMIT,
        method: 'POST',
        transformRequest: (data: any) => {
          const submittedTime = data?.submitQAQCsTime?.submittedTime;
          const needToSubmittedTime =
            data?.submitQAQCsTime?.needToSubmittedTime;
          if (
            data?.submitQAQCsTime &&
            submittedTime !== 0 &&
            submittedTime < needToSubmittedTime
          ) {
            return {
              id: data?.id,
              paintingExecution:
                data?.qaqcInfo?.listQAQCDetail?.[submittedTime]
                  ?.paintingConditionExecution,
              remarks: data?.reason,
            };
          } else if (data?.submitQAQCsTime && submittedTime === 0) {
            return {
              id: data?.id,
              surfacePreparation:
                data?.qaqcInfo?.listQAQCDetail?.[0]?.surfacePrep,
              paintingExecution:
                data?.qaqcInfo?.listQAQCDetail?.[submittedTime]
                  ?.paintingConditionExecution,
              remarks: data?.reason,
            };
          } else if (data?.final) {
            return { id: data?.id, paintingCIF: data?.dataCifClosure };
          }
        },
      },
      title: 'Submit',
      type: TYPE.SUBMIT,
      checkRole: () => {
        return auth?.checkRole(status, 'SUBMITTED');
      },
      popUp: true,
    },
  ];
};

const getConfigPaniting = (status: any, auth: any) => {
  return [
    {
      id: 1,
      key: 'All',
      request: {
        name: 'Submit',
        url: APIS.PAINTING_WORK_DETAIL,
        method: 'POST',
        transformRequest: (data: any) => {
          const { submittedTime, needToSubmittedTime } = data.submitQAQCsTime;
          let billingDetail;
          if (submittedTime === needToSubmittedTime - 1) {
            billingDetail = {
              poNumber: data?.proposalBillingDetail?.poNumber,
              billingDetailUpdate: data?.proposalBillingDetail?.data,
              attachments: data?.attachments,
            };
          }
          return {
            id: data?.id,
            surfacePreparation:
              data?.qaqcInfo?.listQAQCDetail?.[0]?.surfacePrep,
            paintingExecution:
              data?.qaqcInfo?.listQAQCDetail?.[submittedTime]
                ?.paintingConditionExecution,
            billingDetail,
          };
        },
      },
      title: 'Submit',
      type: TYPE.SUBMIT,
      checkRole: () => {
        return auth?.checkRole(status, 'SUBMITTED');
      },
      popUp: false,
    },
  ];
};

const PaintingButons = (props: any) => {
  const { statusRequest, onResetMessageNotice, listPanels } = props;
  const navigate = useNavigate();
  const [auth] = useAuth();
  const [showPopup, setShowPopup] = useState('');
  const [isSubmit, setisSubmit] = useState(true);
  const [formContext] = useFormContext();
  const isFirstCoat = formContext.form?.getFieldValue('submitQAQCsTime');
  const handleCancelSubmit = () => {
    setShowPopup('');
  };
  const getConfigPanitings = (status: any, authvalue: any) => {
    return [
      {
        id: 1,
        key: 'All',
        request: {
          name: 'Submit',
          url: APIS.PAINTING_WORK_DETAIL,
          method: 'POST',
          transformRequest: (data: any) => {
            const { submittedTime, needToSubmittedTime } = data.submitQAQCsTime;
            let billingDetail;
            if (submittedTime === needToSubmittedTime - 1) {
              billingDetail = {
                poNumber: data?.proposalBillingDetail?.poNumber,
                billingDetailUpdate: data?.proposalBillingDetail?.data,
                attachments: data?.attachments,
              };
            }
            if (data.id == undefined) {
              data.id = formContext.form?.getFieldValue('id');
            }
            return {
              id: data?.id,
              surfacePreparation:
                data?.qaqcInfo?.listQAQCDetail?.[0]?.surfacePrep,
              paintingExecution:
                data?.qaqcInfo?.listQAQCDetail?.[submittedTime]
                  ?.paintingConditionExecution,
              billingDetail,
            };
          },
        },
        title: 'Submit',
        type: TYPE.SUBMIT,
        checkRole: () => {
          return authvalue?.checkRole(status, 'SUBMITTED');
        },
        popUp: false,
      },
    ];
  };
  const handleSubmitSuccess = (dataResponse: any) => {
    if (dataResponse?.code === 1) {
      if (statusRequest?.id) {
        navigate(
          `/insulation/view/${statusRequest?.id}?type=${get(
            REQUEST_TYPE,
            statusRequest.type || REQUEST_TYPE.INSTATEMENT,
          )}`,
        );
      } else {
        navigate(
          `/insulation/view/${dataResponse?.data?.requestId}?type=${get(
            REQUEST_TYPE,
            statusRequest.type || REQUEST_TYPE.INSTATEMENT,
          )}`,
        );
      }
    }
    onResetMessageNotice(dataResponse);
  };

  const REQUEST_STATUS = {
    DRAFT: [
      {
        id: 1,
        key: 'All',
        request: {
          name: 'SaveDraft',
          url: APIS.CREATE_PAINTING_REQUEST,
          method: 'POST',
          transformRequest: (data: any) => {
            const { reason, ...newData } = data;
            const attachments = data?.attachments ? data?.attachments : [];
            const searchtype = formContext.form?.getFieldValue('searchType');
            console.log(searchtype);
            if (searchtype === 'scaffoldId') {
              newData['ScaffoldDetail'] = newData['listScaffoldDetail'];
              newData['listScaffoldDetail'] = [];
            }
            return {
              ...newData,
              service: getServiceByURL(statusRequest.type),
              isSaveDraft: true,
              attachments,
            };
          },
        },
        title: 'Save Draft',
        checkRole: () => {
          return auth?.checkRole('DRAFT', 'SUBMITTED');
        },
        popUp: false,
      },
      {
        id: 3,
        key: 'All',
        request: {
          name: 'Submit',
          url: APIS.CREATE_PAINTING_REQUEST,
          method: 'POST',
          transformRequest: (data: any) => {
            const { reason, ...remain } = data;
            const attachments = data?.attachments ? data?.attachments : [];
            const searchtype = formContext.form?.getFieldValue('searchType');
            console.log(searchtype);
            if (searchtype === 'scaffoldId') {
              remain['ScaffoldDetail'] = remain['listScaffoldDetail'];
              remain['listScaffoldDetail'] = [];
            }
            return {
              ...remain,
              coatingSystem: data.coatingSystem,
              serviceCategory: data.serviceCategory,
              environment: data.environment,
              remarks: reason,
              attachments,
            };
          },
        },
        title: 'Submit',
        type: TYPE.SUBMIT,
        checkRole: () => {
          return auth?.checkRole('DRAFT', 'SUBMITTED');
        },
        popUp: true,
      },
    ],
    PENDING_VALIDTION: [
      {
        id: 1,
        key: 'All',
        request: {
          name: 'Reject',
          url: APIS.REJECT_PAINTING_REQUEST,
          method: 'POST',
          transformRequest: (data: any) => {
            const remarks = data.reason;
            return {
              id: data.id,
              remarks,
            };
          },
        },
        title: 'Reject',
        remarksRequired: true,
        checkRole: () => {
          return auth?.checkRole('PENDING_VALIDTION', 'REJECTED', 'PAINTING');
        },
        popUp: true,
      },
      {
        id: 2,
        key: 'All',
        request: {
          name: 'Submit',
          url: APIS.CREATE_VALIDATION_PAINTING_DETAIL,
          method: 'POST',
          transformRequest: (data: any) => {
            const remarks = data.reason;
            const appendData: { [name: string]: any } = {};
            if (data?.otherCoatsList && data?.systemId === 69) {
              appendData.otherCoatsList = data.otherCoatsList.filter(
                (item: any, index: number) => {
                  if (
                    item?.specification ||
                    item?.nominal ||
                    item?.surfaceProfile
                  ) {
                    item['coat'] = index + 1;
                  }
                  return (
                    item?.specification || item?.nominal || item?.surfaceProfile
                  );
                },
              );
            }
            const searchtype = formContext.form?.getFieldValue('searchType');
            console.log(searchtype);
            if (searchtype === 'scaffoldId') {
              data['ScaffoldDetail'] = data['listScaffoldDetail'];
              data['listScaffoldDetail'] = [];
            }
            const {
              section,
              discipline,
              area,
              startDate,
              endDate,
              isWorkDetailRequire,
              isScaffoldingRequire,
              siteVisitDate,
              listWorkDetail,
              listScaffoldDetail,
              workDescription,
              workDetailRemarks,
              attachments,
            } = data;
            return {
              id: data.id,
              qaqcSupervisorId: data?.qaqcSupervisorId,
              coatingTestRequired: data.coatingTestRequired,
              remarks,
              systemId: data.systemId,
              surfacePreparation: data.surfacePreparation,
              mlngciAssignedName: data.mlngciAssignedName,
              workAssigned: data.workAssigned,
              serviceCategory: data.serviceCategory,
              coatingSystem: data.coatingSystem,
              environment: data.environment,
              section,
              discipline,
              area,
              startDate,
              endDate,
              isWorkDetailRequire,
              isScaffoldingRequire,
              siteVisitDate,
              listWorkDetail,
              listScaffoldDetail,
              workDescription,
              workDetailRemarks,
              attachments,
              ...appendData,
              ScaffoldDetail: data.ScaffoldDetail,
            };
          },
        },
        title: 'Submit',
        type: TYPE.SUBMIT,
        checkRole: () => {
          return auth?.checkRole('PENDING_VALIDTION', 'SUBMITTED', 'PAINTING');
        },
        popUp: true,
      },
      {
        id: 3,
        key: 'All',
        title: 'Submit',
        type: TYPE.SUBMIT,
        popUp: true,
        request: {
          name: 'editValidtion',
          url: APIS.EDIT_PAINTING_REQUEST,
          method: 'PUT',

          transformRequest: (data: any) => {
            const { reason, ...newData } = data;
            const searchtype = formContext.form?.getFieldValue('searchType');
            console.log(searchtype);
            if (searchtype === 'scaffoldId') {
              newData['ScaffoldDetail'] = newData['listScaffoldDetail'];
              newData['listScaffoldDetail'] = [];
            }

            return {
              ...newData,
              remarks: data.reason,
              service: getServiceByURL(statusRequest.type),
            };
          },
        },
        checkRole: () => {
          return auth?.checkRole('PENDING_VALIDTION', 'EDITED');
        },
      },
    ],
    PENDING_PROPOSAL: [
      {
        id: 1,
        key: 'All',
        request: {
          name: 'Reject',
          url: APIS.PROPOSAL_REJECT,
          method: 'POST',
          transformRequest: (data: any) => {
            const { id, reason } = data;
            return {
              id,
              reason,
            };
          },
        },
        title: 'Reject',
        remarksRequired: true,
        checkRole: () => {
          return auth?.checkRole('REQUEST_PROPOSAL', 'REJECTED');
        },
        popUp: true,
      },
      {
        id: 2,
        key: 'All',
        request: {
          name: 'Save',
          url: APIS.PROPOSAL_SUBMIT,
          method: 'POST',
          transformRequest: (data: any) => {
            return {
              id: data.id,
              billingDetails: data.proposalBillingDetail.data,
              attachments: data.proposalBillingDetail.attachments,
              isSubmit: false,
            };
          },
        },
        title: 'Save',
        checkRole: () => {
          return auth?.checkRole('REQUEST_PROPOSAL', 'SUBMITTED');
        },
        popUp: false,
      },
      {
        id: 3,
        key: 'All',
        request: {
          name: 'Submit',
          url: APIS.PROPOSAL_SUBMIT,
          method: 'POST',
          transformRequest: (data: any) => {
            return {
              id: data.id,
              billingDetails: data.proposalBillingDetail.data,
              attachments: data.proposalBillingDetail.attachments,
              isSubmit: true,
              remarks: data.reason,
            };
          },
        },
        title: 'Submit',
        type: TYPE.SUBMIT,
        checkRole: () => {
          return auth?.checkRole('REQUEST_PROPOSAL', 'SUBMITTED');
        },
        popUp: true,
      },
    ],
    PENDING_REMOVAL: [
      {
        id: 1,
        key: 'All',
        request: {
          name: 'Save',
          url: APIS.REMOVAL_COMPLETION_SUBMIT,
          method: 'POST',
          transformRequest: (data: any) => {
            const { insulationRemovalDetail, id } = data;
            return {
              id,
              ...insulationRemovalDetail,
              isSubmit: false,
            };
          },
        },
        title: 'Save',
        checkRole: () => {
          return auth?.checkRole('PENDING_REMOVAL', 'SUBMITTED');
        },
        popUp: false,
      },
      {
        id: 2,
        key: 'All',
        request: {
          name: ' Submit',
          url: APIS.REMOVAL_COMPLETION_SUBMIT,
          method: 'POST',
          transformRequest: (data: any) => {
            const { insulationRemovalDetail, id, reason } = data;
            const dataChecklist: any = {};
            forEach(reason, (value: any, key: any) => {
              if (value !== '') {
                dataChecklist[key] = value;
              }
            });
            return {
              ...dataChecklist,
              ...insulationRemovalDetail,
              id,
              isSubmit: true,
            };
          },
        },
        title: 'Submit',
        type: TYPE.SUBMIT,
        checkRole: () => {
          return auth?.checkRole('PENDING_REMOVAL', 'SUBMITTED');
        },
        popUp: true,
      },
    ],
    IN_SERVICE: [],
    PENDING_REINSTATEMENT: [
      {
        id: 1,
        key: 'All',
        request: {
          name: ' Save',
          url: APIS.REINSTATEMENT_COMPLETION,
          method: 'POST',
          transformRequest: (data: any) => {
            const { insulationReinstatementDetail, id } = data;

            return {
              id,
              ...insulationReinstatementDetail,
              workItemDetail: data.proposalBillingDetail.data,
              poNumber: data.proposalBillingDetail.poNumber,
              totalQuotedCost: data.proposalBillingDetail.totalFinalCost,
              isSubmit: false,
            };
          },
        },
        title: 'Save',
        checkRole: () => {
          return auth?.checkRole('PENDING_REINSTATEMENT', 'SUBMITTED');
        },
        popUp: false,
      },
      {
        id: 2,
        key: 'All',
        request: {
          name: ' Submit',
          url: APIS.REINSTATEMENT_COMPLETION,
          method: 'POST',
          transformRequest: (data: any) => {
            const { insulationReinstatementDetail, id } = data;
            return {
              id,
              ...insulationReinstatementDetail,
              workItemDetail: data.proposalBillingDetail.data,
              poNumber: data.proposalBillingDetail.poNumber,
              totalQuotedCost: data.proposalBillingDetail.totalFinalCost,
              isSubmit: true,
            };
          },
        },
        title: 'Submit',
        type: TYPE.SUBMIT,
        checkRole: () => {
          return auth?.checkRole('PENDING_REINSTATEMENT', 'SUBMITTED');
        },
        popUp: false,
      },
    ],
    PENDING_QAQC: [
      {
        id: 1,
        key: 'All',
        request: {
          name: 'Submit',
          url: APIS.QAQC_PAINTING_SUBMIT,
          method: 'POST',
          transformRequest: (data: any) => {
            if (data?.final) {
              return { id: data?.id, paintingCIF: data?.dataCifClosure };
            } else {
              return {
                id: data?.id,
                surfacePreparation:
                  data?.qaqcInfo?.listQAQCDetail?.[0]?.surfacePrep,
                paintingExecution:
                  data?.qaqcInfo?.listQAQCDetail?.[0]
                    ?.paintingConditionExecution,
              };
            }
          },
        },
        title: 'Submit',
        type: TYPE.SUBMIT,
        checkRole: () => {
          return auth?.checkRole('PENDING_QAQC', 'SUBMITTED', 'PAINTING');
        },
        popUp: true,
      },
    ],
    PENDING_QAQC_1: getConfigQAQC('PENDING_QAQC_1', auth),
    PENDING_QAQC_2: getConfigQAQC('PENDING_QAQC_2', auth),
    PENDING_QAQC_3: getConfigQAQC('PENDING_QAQC_3', auth),
    PENDING_QAQC_4: getConfigQAQC('PENDING_QAQC_4', auth),
    PENDING_QAQC_5: getConfigQAQC('PENDING_QAQC_5', auth),

    BILLING: [
      {
        id: 1,
        key: 'All',
        request: {
          name: 'Save',
          url: APIS.PAINTING_BILLING,
          method: 'POST',
          transformRequest: (data: any) => {
            const { poNumber, verifiedFinalCost, executiveInCharge, date } =
              data.proposalBillingDetail;
            return {
              id: data.id,
              poNumber,
              verifiedFinalCost,
              isSubmit: false,
              executiveInCharge,
              date,
            };
          },
        },
        title: 'Save',
        checkRole: () => {
          return auth?.checkRole('BILLING', 'SAVED', 'PAINTING');
        },
        popUp: false,
      },
      {
        id: 2,
        key: 'All',
        request: {
          name: 'Submit',
          url: APIS.PAINTING_BILLING,
          method: 'POST',
          transformRequest: (data: any) => {
            const { poNumber, verifiedFinalCost, executiveInCharge, date } =
              data.proposalBillingDetail;
            return {
              id: data.id,
              poNumber,
              verifiedFinalCost,
              isSubmit: true,
              executiveInCharge,
              date,
            };
          },
        },
        title: 'Submit',
        type: TYPE.SUBMIT,
        checkRole: () => {
          return auth?.checkRole('BILLING', 'SUBMITTED', 'PAINTING');
        },
        popUp: false,
      },
    ],
    CLOSED: [],
    PENDING_PAINTING: [
      {
        id: 1,
        key: 'All',
        request: {
          name: 'Submit',
          url: APIS.PAINTING_WORK_DETAIL,
          method: 'POST',
          transformRequest: (data: any) => {
            if (data.id == undefined) {
              data.id = formContext.form?.getFieldValue('id');
            }
            return {
              id: data?.id,
              surfacePreparation:
                data?.qaqcInfo?.listQAQCDetail?.[0]?.surfacePrep,
              paintingExecution:
                data?.qaqcInfo?.listQAQCDetail?.[0]?.paintingConditionExecution,
              billingDetail: {
                poNumber: data?.proposalBillingDetail?.poNumber,
                billingDetailUpdate: data?.proposalBillingDetail?.data,
                attachments: data?.attachments,
              },
            };
          },
        },
        title: 'Submit',
        type: TYPE.SUBMIT,
        checkRole: () => {
          return auth?.checkRole('PENDING_PAINTING', 'SUBMITTED');
        },
        popUp: false,
      },
    ],
    PENDING_PAINTING_1: getConfigPanitings('PENDING_PAINTING_1', auth),
    PENDING_PAINTING_2: getConfigPanitings('PENDING_PAINTING_2', auth),
    PENDING_PAINTING_3: getConfigPanitings('PENDING_PAINTING_3', auth),
    PENDING_PAINTING_4: getConfigPanitings('PENDING_PAINTING_4', auth),
    PENDING_PAINTING_5: getConfigPanitings('PENDING_PAINTING_5', auth),
  };

  const handleEvent = (key: string) => {
    setShowPopup(key);
  };

  const handleConfirmEvent = (
    requestId?: string,
    actionProps?: any,
    reason?: any,
    key?: string,
  ) => {
    if (key === 'All') {
      const newData = convertMomentToString(actionProps?.getFormValues());
      const id = requestId;
      actionProps.submitData(
        correctData({
          ...newData,
          reason,
          id,
        }),
      );
    } else {
      const data = key && actionProps.field?.getFieldsValue()?.[key];
      actionProps.submitData(correctData({ requestId, data, reason }));
    }
    setShowPopup('');
  };

  const handleConfirmSubmit = (
    record: any,
    remarkText: any,
    actionProps: any,
  ) => {
    console.log(actionProps, 'actionProps');
    actionProps.submitData({
      id: record,
      reason: remarkText,
    });
    setShowPopup('');
  };
  const checkStatus = () => {
    const buttons = get(REQUEST_STATUS, statusRequest?.status, []);
    for (const item of buttons) {
      console.log(item?.checkRole(), item, props, 'item');
      if (item?.checkRole && item?.checkRole()) {
        return true;
      }
    }
    return false;
  };

  const checkFinalQaqc = (actionProps?: any) => {
    const newData = convertMomentToString(actionProps?.getFormValues());
    if (!newData?.submitQAQCsTime || newData?.status !== 8) {
      return false;
    }
    return (
      newData?.submitQAQCsTime?.needToSubmittedTime ===
      newData?.submitQAQCsTime?.submittedTime
    );
  };

  const handleSendbackSuccess = () => {
    window.location.reload();
  };
  const showMessage = (code: number) => {
    if (code === 1) {
      notification['success']({
        message: 'Successfully!',
      });
    }
  };
  const requestId = formContext.form?.getFieldValue('id');
  const checkActionRequest = () => {
    if (statusRequest?.state === 'VIEW') {
      return checkStatus() ? (
        <Space size={10}>
          {isFirstCoat?.submittedTime === 0 &&
            statusRequest.status === 'PENDING_QAQC' && (
              <Button size="middle" onClick={() => handleEvent('send back')}>
                Send Back
              </Button>
            )}
          {isFirstCoat?.submittedTime === 0 &&
            statusRequest.status === 'PENDING_QAQC_1' && (
              <Button size="middle" onClick={() => handleEvent('send back')}>
                Send Back
              </Button>
            )}

          <Button
            size="middle"
            onClick={() => {
              navigate(
                `/insulation/edit/${statusRequest?.id}?type=${get(
                  REQUEST_TYPE,
                  statusRequest?.type || REQUEST_TYPE.INSTATEMENT,
                )}`,
              );
            }}
          >
            Edit
          </Button>

          {showPopup === 'send back' && (
            <ActionField
              name={'submit'}
              request={{
                name: 'submit',
                url: APIS.SENDBACK_REQUEST_CONTRACTOR_QAQC,
                method: 'POST',
              }}
              onResponseData={(dataRes: any) => {
                if (dataRes?.code === 2) {
                  notification['error']({
                    message: `Submit ${
                      MAP_REQUEST_NAME[statusRequest?.status] || 'Error'
                    }`,
                    description: dataRes?.message,
                  });
                } else if (dataRes?.code === 1) {
                  handleSendbackSuccess();
                }
              }}
            >
              {(actionProps: any) => {
                return (
                  <Popup
                    title={`SendBack confirmation`}
                    isVisible={true}
                    handleOk={(remarks: string) => {
                      handleConfirmSubmit(requestId, remarks, actionProps);
                    }}
                    handleCancel={handleCancelSubmit}
                    description={`Are you sure you want to Send Back this request?`}
                    tittleContent={'Remarks'}
                    requireContent={true}
                    hintTextArea={
                      'Please write the reason to Send Back the request'
                    }
                  />
                );
              }}
            </ActionField>
          )}
        </Space>
      ) : null;
    }
    return (
      <Space size={10}>
        {get(REQUEST_STATUS, statusRequest?.status, []).map((item: any) => {
          if (item?.checkRole && !item?.checkRole()) return null;
          if (item && item?.request) {
            return (
              <ActionField
                key={item?.id}
                name={item?.request?.name}
                request={item?.request as Request}
                onResponseData={(dataRes: any) => {
                  if (dataRes?.code === 2) {
                    notification['error']({
                      message: `Submit ${
                        MAP_REQUEST_NAME[statusRequest?.status] || 'Error'
                      }`,
                      description: dataRes?.message,
                    });
                  } else if (dataRes?.code === 1) {
                    handleSubmitSuccess(dataRes);
                  }
                }}
              >
                {(actionProps: ActionFieldChildProps) => {
                  const missingInfoFormList = validateData(
                    actionProps,
                    listPanels,
                    statusRequest?.status,
                    { checkRole: auth.checkRole },
                  );
                  // const requestId = formContext.form?.getFieldValue('id');
                  const checkFinalSubmitQaqc = checkFinalQaqc(actionProps);

                  const validateInputData = () => {
                    //validate workDetail
                    const errors = [];
                    const isWd =
                      actionProps?.getFormValues().isWorkDetailRequire;
                    const listWorkDetail =
                      actionProps?.getFormValues().listWorkDetail || [];
                    const currentWorkDetail =
                      listWorkDetail.length == 0 ? '' : 1;
                    const currentArea = actionProps?.getFormValues().area;
                    const currentStartDate =
                      actionProps?.getFormValues().startDate || '';
                    const currentEndDate =
                      actionProps?.getFormValues().endDate || '';
                    const workRemarks =
                      actionProps?.getFormValues().workDetailRemarks;
                    if (statusRequest?.status === 'PENDING_VALIDTION') {
                      if (currentWorkDetail === '' && isWd === true) {
                        errors.push('-Work Detail');
                      }

                      if (currentArea == null) {
                        errors.push('-Area (Painting Detail)');
                      }

                      if (currentStartDate === '') {
                        errors.push('-Start Date (Painting Detail)');
                      }

                      if (currentEndDate === '') {
                        errors.push('-End Date (Painting Detail)');
                      }

                      if (
                        (workRemarks === null || workRemarks.length < 20) &&
                        isWd === false
                      ) {
                        errors.push('-Reason should be more than 20 words');
                      }
                    }

                    if (statusRequest?.status === 'DRAFT') {
                      if (currentWorkDetail === '' && isWd === true) {
                        errors.push('-Work Detail');
                      }

                      if (currentArea == null) {
                        errors.push('-Area (Painting Detail)');
                      }

                      if (currentStartDate === '') {
                        errors.push('-Start Date (Painting Detail)');
                      }

                      if (currentEndDate === '') {
                        errors.push('-End Date (Painting Detail)');
                      }

                      if (
                        (workRemarks === undefined ||
                          workRemarks.length < 20) &&
                        isWd === false
                      ) {
                        errors.push('-Reason should be more than 20 words');
                      }
                    }
                    return errors;
                  };

                  return (
                    <>
                      <Button
                        size="middle"
                        type={
                          item?.type === TYPE.SUBMIT ? 'primary' : 'default'
                        }
                        onClick={() => {
                          const errors = validateInputData();

                          if (errors.length > 0) {
                            const errorMessages = errors.join(', ');
                            alert(
                              `Please fill in: \n${errorMessages.replace(
                                /, /g,
                                '\n',
                              )}`,
                            );
                          } else {
                            if (item?.onClick) {
                              item?.onClick(actionProps);
                            } else if (!item?.popUp) {
                              handleConfirmEvent(
                                requestId,
                                actionProps,
                                '',
                                item?.key,
                              );
                            } else {
                              handleEvent(item?.request?.name);
                            }
                            onResetMessageNotice({
                              code: 0,
                              message: '',
                              data: 0,
                            });
                          }
                        }}
                      >
                        {item?.title}
                      </Button>

                      {item?.popUp ? (
                        <>
                          {statusRequest?.status === 'PENDING_REMOVAL' && (
                            <RemovalChecklist
                              visible={showPopup === item?.request?.name}
                              handleCancel={handleCancelSubmit}
                              handleSubmit={(checkListData: any) =>
                                handleConfirmEvent(
                                  requestId,
                                  actionProps,
                                  checkListData,
                                  item?.key,
                                )
                              }
                            />
                          )}
                          {(statusRequest?.status === 'PENDING_QAQC_2' ||
                            statusRequest?.status === 'PENDING_QAQC_3' ||
                            statusRequest?.status === 'PENDING_QAQC_4' ||
                            statusRequest?.status === 'PENDING_QAQC_5' ||
                            statusRequest?.status === 'PENDING_QAQC') &&
                            checkFinalSubmitQaqc && (
                              <PopupFinalSubmitQaqc
                                visible={showPopup === item?.request?.name}
                                handleCancel={handleCancelSubmit}
                                handleSubmit={(dataCifClosure: any) =>
                                  actionProps.submitData({
                                    dataCifClosure,
                                    final: true,
                                    id: requestId,
                                  })
                                }
                              />
                            )}
                          {statusRequest?.status !== 'PENDING_REMOVAL' &&
                            !checkFinalSubmitQaqc && (
                              <Popup
                                title={`${item?.title} Confirmation`}
                                isVisible={showPopup == item?.request?.name}
                                handleOk={(remarks: string) => {
                                  handleConfirmEvent(
                                    requestId,
                                    actionProps,
                                    remarks,
                                    item?.key,
                                  );
                                }}
                                handleCancel={handleCancelSubmit}
                                description={`Are you sure you want to ${item?.title} request`}
                                tittleContent={
                                  actionProps?.getFormValues()
                                    .lastSubmittedStatus === 7
                                    ? 'Remarks'
                                    : 'Remarks (Optional)'
                                }
                                requireContent={
                                  actionProps?.getFormValues()
                                    .lastSubmittedStatus === 7
                                    ? true
                                    : false
                                }
                                status={statusRequest?.status}
                                lastSubmittedStatus={
                                  actionProps?.getFormValues()
                                    .lastSubmittedStatus
                                }
                              />
                            )}
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  );
                }}
              </ActionField>
            );
          } else {
            return null;
          }
        })}
      </Space>
    );
  };

  return (
    <div className="group-button">{statusRequest && checkActionRequest()}</div>
  );
};

export default PaintingButons;
